<template>
    <SignupForm manager="true" />
</template>

<script>
    import SignupForm from "../shared/SignupForm.vue"

    export default {
        components: {
            SignupForm
        }
    }
</script>